export default __webpack_public_path__ + "static/media/whatsappIcon.fcfbfa7e.svg";